import React from "react";
import { Grid } from "@mui/material";

import Input from "../ReadOnlyInput";
import {
  formatMonetary,
  formatPercentage,
  timeStampToDate,
  formatUpperCase,
} from "../../../../utils/formats";
import { Separator, Label } from "../styles";

const DadosOperacaoSection = (props) => {
  const {
    proposalOperationLoading,
    proposalInfoWarrantyLoading,
    paymentTypesLoading,
    valorTotalFinanciado,
    valorProposta,
    retorno,
    valorEntrada,
    quantidadePrestacoes,
    valorPrestacao,
    valorLiquido,
    valorContrato,
    valorIof,
    dataVencimentoPrimeiraPrestacao,
    dataVencimentoUltimaPrestacao,
    taxaMes,
    taxaAA,
    cetAm,
    cetAA,
    valorTac,
    valorSeguro,
    valorOutros,
    valorMercado,
    produto,
    operationTotalValue,
    valorVenda,
    sistemaOrigem,
    paymentTypes,
    proposalCompleteRegistrationLoading,
    dadosAdicionais,
  } = props;

  return (
    <>
      <Grid container spacing={3}>
        <Grid item md={4}>
          <Input
            loading={proposalOperationLoading}
            label="Valor total financiado (EM)"
            value={formatMonetary(valorContrato)}
          />
        </Grid>
        <Grid item md={4}>
          <Input
            loading={proposalOperationLoading}
            label="Valor líquido/liberado (loja)"
            value={formatMonetary(valorLiquido)}
          />
        </Grid>
        <Grid item md={4}>
          <Input
            loading={proposalOperationLoading}
            label="Retorno"
            value={formatUpperCase(retorno)}
          />
        </Grid>
        <Grid item md={4}>
          <Input
            loading={proposalOperationLoading}
            label="Valor do Veículo (Financiado)"
            value={formatMonetary(
              sistemaOrigem === "FANDI" &&
                dadosAdicionais?.vlFinanciadoErp != null
                ? dadosAdicionais.vlFinanciadoErp
                : operationTotalValue
            )}
          />
        </Grid>
        <Grid item md={4}>
          <Input
            loading={proposalInfoWarrantyLoading}
            label="Valor do Veículo (Garantia)"
            value={formatMonetary(valorVenda)}
          />
        </Grid>
        {sistemaOrigem && (
          <Grid item md={4}>
            <Input
              loading={proposalOperationLoading}
              label="Origem"
              value={sistemaOrigem}
            />
          </Grid>
        )}
        <Grid item md={4}>
          <Input
            loading={proposalInfoWarrantyLoading}
            label="Valor FIPE"
            value={formatMonetary(valorMercado)}
          />
        </Grid>
        <Grid item md={4}>
          <Input
            loading={paymentTypesLoading}
            label="Valor de entrada"
            value={formatMonetary(
              sistemaOrigem === "FANDI" && dadosAdicionais?.vlEntradaErp != null
                ? dadosAdicionais.vlEntradaErp
                : paymentTypes?.valorEntrada
            )}
          />
        </Grid>
        <Grid item md={4}>
          <Input
            loading={paymentTypesLoading}
            label="Percentual entrada"
            value={
              sistemaOrigem === "FANDI" && dadosAdicionais?.pcEntradaErp != null
                ? formatPercentage(dadosAdicionais.pcEntradaErp)
                : paymentTypes?.percentualEntrada != null
                ? formatPercentage(paymentTypes?.percentualEntrada)
                : "-"
            }
          />
        </Grid>
      </Grid>

      {sistemaOrigem === "FANDI" && dadosAdicionais?.idOrigem != null && (
        <>
          <Separator />
          <Label>Dados adicionais</Label>
          <Grid container spacing={3}>
            <Grid item md={3}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Origem da proposta"
                value={dadosAdicionais?.idOrigem}
              />
            </Grid>
            <Grid item md={3}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Código ERP (ficha)"
                value={dadosAdicionais?.cdFicha}
              />
            </Grid>
            <Grid item md={3}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="ID Único pedido (UUID)"
                value={dadosAdicionais?.idUuid}
              />
            </Grid>
            <Grid item md={3}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Código Condição"
                value={dadosAdicionais?.cdCondicao}
              />
            </Grid>
            <Grid item md={3}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Valor Veículo Financiado ERP"
                value={formatMonetary(dadosAdicionais?.vlFinanciadoErp)}
              />
            </Grid>
            <Grid item md={3}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Valor Total Financiado ERP"
                value={formatMonetary(dadosAdicionais?.vlFinanciadoTotalErp)}
              />
            </Grid>
            <Grid item md={3}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Valor Entrada Recebido via API"
                value={formatMonetary(dadosAdicionais?.vlEntradaApi)}
              />
            </Grid>
            <Grid item md={3}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Percentual de Entrada recebido API"
                value={formatPercentage(dadosAdicionais?.pcEntradaApi)}
              />
            </Grid>
            <Grid item md={3}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Valor Entrada ERP"
                value={formatMonetary(dadosAdicionais?.vlEntradaErp)}
              />
            </Grid>
            <Grid item md={3}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Percentual Entrada ERP"
                value={formatPercentage(dadosAdicionais?.pcEntradaErp)}
              />
            </Grid>
            <Grid item md={3}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Valor Entrada Calculado FIPE/Financiado"
                value={formatMonetary(dadosAdicionais?.vlEntradaCalc)}
              />
            </Grid>
            <Grid item md={3}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Percentual Entrada Calculado FIPE/Financiado"
                value={formatPercentage(dadosAdicionais?.pcEntradaCalc)}
              />
            </Grid>
            <Grid item md={3}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Valor Entrada Calculado Venda/Financiado"
                value={formatMonetary(dadosAdicionais?.vlEntradaCalcVenda)}
              />
            </Grid>
            <Grid item md={3}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Percentual Entrada Calculado Valor Venda/Financiado"
                value={formatPercentage(dadosAdicionais?.pcEntradaCalcVenda)}
              />
            </Grid>
            <Grid item md={3}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Valor de Venda do Veículo"
                value={formatMonetary(dadosAdicionais?.vlVendaFandi)}
              />
            </Grid>
            <Grid item md={3}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Código único simulação"
                value={dadosAdicionais?.idSimulacao}
              />
            </Grid>
          </Grid>
        </>
      )}

      <Separator />

      <Grid container spacing={3}>
        <Grid item md={3}>
          <Input
            loading={proposalOperationLoading}
            label="Quantidade de prestações"
            value={quantidadePrestacoes}
          />
        </Grid>
        <Grid item md={3}>
          <Input
            loading={proposalOperationLoading}
            label="Valor das prestações"
            value={formatMonetary(valorPrestacao)}
          />
        </Grid>
        <Grid item md={3}>
          <Input
            loading={proposalOperationLoading}
            label="Valor líquido/liberado (loja)"
            value={formatMonetary(valorLiquido)}
          />
        </Grid>
        <Grid item md={3}>
          <Input
            loading={proposalOperationLoading}
            label="Valor do contrato"
            value={formatMonetary(valorContrato)}
          />
        </Grid>

        <Grid item md={3}>
          <Input
            loading={proposalOperationLoading}
            label="Valor do IOF"
            value={formatMonetary(valorIof)}
          />
        </Grid>
        <Grid item md={3}>
          <Input
            loading={proposalOperationLoading}
            label="Data vcto. (1ª prestação)"
            value={timeStampToDate(dataVencimentoPrimeiraPrestacao)}
          />
        </Grid>
        <Grid item md={3}>
          <Input
            loading={proposalOperationLoading}
            label="Data vcto. (último prestação)"
            value={timeStampToDate(dataVencimentoUltimaPrestacao)}
          />
        </Grid>
        <Grid item md={3}>
          <Input
            loading={proposalOperationLoading}
            label="Taxa a.m."
            value={formatPercentage(taxaMes)}
          />
        </Grid>

        <Grid item md={3}>
          <Input
            loading={proposalOperationLoading}
            label="Taxa a.a."
            value={formatPercentage(taxaAA)}
          />
        </Grid>
        <Grid item md={3}>
          <Input
            loading={proposalOperationLoading}
            label="Taxa CET a.m."
            value={formatPercentage(cetAm)}
          />
        </Grid>
        <Grid item md={3}>
          <Input
            loading={proposalOperationLoading}
            label="Taxa CET a.a."
            value={formatPercentage(cetAA)}
          />
        </Grid>
        <Grid item md={3}>
          <Input
            loading={proposalOperationLoading}
            label="Valor TAC"
            value={formatMonetary(valorTac)}
          />
        </Grid>

        <Grid item md={3}>
          <Input
            loading={proposalOperationLoading}
            label="Valor do seguro"
            value={formatMonetary(valorSeguro)}
          />
        </Grid>
        <Grid item md={3}>
          <Input
            loading={proposalOperationLoading}
            label="Valor (outros)"
            value={formatMonetary(valorOutros)}
          />
        </Grid>
        <Grid item md={3}>
          <Input
            loading={proposalOperationLoading}
            label="Produto"
            value={formatUpperCase(produto)}
          />
        </Grid>
        <Grid item md={3}>
          <Input
            loading={proposalOperationLoading}
            label="Saldo devedor"
            value={formatMonetary(valorTotalFinanciado)}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default DadosOperacaoSection;
